import { Breadcrumb as AntdBreadcrumb } from 'antd';
import './Breadcrumb.scss';

const Breadcrumb = ({ items, ...props }) => {
  return (
    <AntdBreadcrumb
      {...props}
      separator={
        <span className="w-[20px] h-[20px]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M10.4993 10L6.66602 6.16667L7.83268 5L12.8327 10L7.83268 15L6.66602 13.8333L10.4993 10Z"
              fill="#818589"
            />
          </svg>
        </span>
      }
      items={[...items]}
    />
  );
};

export default Breadcrumb;
